import { IUser } from 'redux/store/user/types'
import { ProfileAbilityBuilder, UpdateAbilityContext } from '../types'
import { ACTIONS, ROLES, SUBJECTS } from 'features/Permission/constants'

export const defineCommonsProfileAbilities = (
  builder: ProfileAbilityBuilder,
  role: string,
  user: IUser,
  profileId?: string
) => {
  const { can } = builder
  can(ACTIONS.ARCHIVE, SUBJECTS.USER)
  can(ACTIONS.EDIT, SUBJECTS.FORM_HOSPITAL_LIST)
  can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY)
  if (
    user.uuid !== profileId &&
    (user.role === ROLES.COMMONS_ANALYST ||
      user.role === ROLES.COMMONS_LEGAL ||
      user.role === ROLES.COMMONS_STAKEHOLDER)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
  }
  if (
    user.role === ROLES.COMMONS_CONTRACT_STEWARD &&
    user.uuid !== profileId &&
    (role === ROLES.COMMONS_VICE_PRESIDENT ||
      role === ROLES.COMMONS_CLINICAL_COORDINATOR ||
      role === ROLES.COMMONS_CONTRACT_STEWARD)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
  }

  if (
    role === ROLES.COMMONS_CLINICAL_COORDINATOR ||
    user.role === ROLES.COMMONS_VICE_PRESIDENT
  ) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_COMMUNITIES_WITH_HS_LIST)
  }

  if (
    role === ROLES.COMMONS_STAKEHOLDER ||
    role === ROLES.COMMONS_LEGAL ||
    role === ROLES.COMMONS_CONTRACT_STEWARD ||
    role === ROLES.COMMONS_ANALYST
  ) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_CONTARCT_CATEGORIES_INPUT)
  }
  if (
    user.role === ROLES.COMMONS_CONTRACT_STEWARD ||
    user.role === ROLES.COMMONS_LEGAL ||
    user.role === ROLES.COMMONS_ANALYST ||
    user.role === ROLES.COMMONS_STAKEHOLDER
  ) {
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_SETTINGS)
  }
  if (
    (user.role === ROLES.COMMONS_CONTRACT_STEWARD ||
      user.role === ROLES.COMMONS_VICE_PRESIDENT) &&
    (role === ROLES.COMMONS_STAKEHOLDER ||
      role === ROLES.COMMONS_LEGAL ||
      role === ROLES.COMMONS_ANALYST)
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
  }

  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT &&
    role === ROLES.COMMONS_CONTRACT_STEWARD
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_ACTIONS)
  }

  if (user.role === ROLES.COMMONS_CONTRACT_STEWARD) {
    can(
      ACTIONS.VIEW,
      SUBJECTS.USER_CONTRACT_CATEGORIES_ASSIGNMENT_STATUS_SETTINGS
    )
  }
  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CLINICAL_COORDINATOR ||
    user.role === ROLES.COMMONS_ANALYST ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD
  ) {
    can(ACTIONS.VIEW, SUBJECTS.CENTRAL_REPOSITORY)
    can(ACTIONS.VIEW, SUBJECTS.AVAILABLE_FOR_EVALUATION)
    can(ACTIONS.VIEW, SUBJECTS.OPPORTUNITY_ANALYSIS)
    can(ACTIONS.VIEW, SUBJECTS.REQUESTS_FOR_ANALYSIS)
  }
}

export const updateCommonsAbilities = (
  builder: ProfileAbilityBuilder,
  ctx: UpdateAbilityContext
) => {
  const { can } = builder
  const { user } = ctx

  // all commons users can have access to bidding and commons users
  can(ACTIONS.VIEW, SUBJECTS.BIDDING)
  can(ACTIONS.VIEW, SUBJECTS.CONTRACTS)
  can(ACTIONS.VIEW, SUBJECTS.COMMONS_USERS)
  can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY)
  can(ACTIONS.VIEW, SUBJECTS.CALENDAR)
  can(ACTIONS.VIEW, SUBJECTS.CHAT)

  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD
  ) {
    can(ACTIONS.CRUD, SUBJECTS.RFP)
    can(ACTIONS.VIEW, SUBJECTS.CONTRACT_PIPELINE)
    can(ACTIONS.CREATE, SUBJECTS.CONTRACT_PIPELINE)
    can(ACTIONS.CRUD, SUBJECTS.COMMONS_USERS)
    can(ACTIONS.EDIT, SUBJECTS.USER)
  }

  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD ||
    user.role === ROLES.COMMONS_ANALYST ||
    user.role === ROLES.COMMONS_STAKEHOLDER ||
    user.role === ROLES.COMMONS_CLINICAL_COORDINATOR
  ) {
    if (
      user.role === ROLES.COMMONS_CLINICAL_COORDINATOR ||
      user.role === ROLES.COMMONS_STAKEHOLDER
    ) {
      can(ACTIONS.CREATE, SUBJECTS.ONLY_GUEST_VENDORS)
    }
    can(ACTIONS.CREATE, SUBJECTS.VENDORS)
  }
  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CLINICAL_COORDINATOR ||
    user.role === ROLES.COMMONS_ANALYST ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD
  ) {
    can(ACTIONS.VIEW, SUBJECTS.CENTRAL_REPOSITORY)
    can(ACTIONS.VIEW, SUBJECTS.AVAILABLE_FOR_EVALUATION)
    can(ACTIONS.VIEW, SUBJECTS.OPPORTUNITY_ANALYSIS)
    can(ACTIONS.VIEW, SUBJECTS.REQUESTS_FOR_ANALYSIS)
  }

  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD
  ) {
    can(ACTIONS.CREATE, SUBJECTS.CONTRACTS)
  }

  if (
    user.role === ROLES.COMMONS_VICE_PRESIDENT ||
    user.role === ROLES.COMMONS_CONTRACT_STEWARD ||
    user.role === ROLES.COMMONS_ANALYST
  ) {
    can(ACTIONS.VIEW, SUBJECTS.COMPLIANCE)
    can(ACTIONS.VIEW, SUBJECTS.FINANCIALS)
  }

  if (
    user.role === ROLES.COMMONS_CONTRACT_STEWARD ||
    user.role === ROLES.COMMONS_VICE_PRESIDENT
  ) {
    can(ACTIONS.CREATE, SUBJECTS.BULK_CONTRACTS)
  }
}
